export const hasPrometheusEnabled = (monitoringAddon) => {
  return monitoringAddon !== undefined && monitoringAddon.status?.healthy === true
}
